export enum PropostaStatusEnum {
	EmNegociacao = 601,
	Emitida = 602,
	Recusada = 604,
	PreAprovada = 606,
	EmSubscricao = 611,
	AprovadaPeloSubscritor = 612,
	EmAnalise = 613
}
